import { FC, useEffect, useRef, useState } from "react";
import { useInterval } from "react-use";

type YOffsetAnnouncerProps = {
  onChange: (yOffset: number) => void;
};

const YOffsetAnnouncer: FC<YOffsetAnnouncerProps> = (props) => {
  const ref = useRef(null);
  const [currentYOffset, setCurrentYOffset] = useState(0);

  // Not proud of this method of checking if the y offset was changed. There seems to be no
  // api for checking that an element moved / changed y offset.
  useInterval(() => {
    if (currentYOffset !== (ref.current as any)?.offsetTop) onYOffsetChange();
  }, 100);

  const onYOffsetChange = () => {
    const yOffset = (ref!.current! as any)?.offsetTop as number;
    // if (yOffset === undefined) return;

    setCurrentYOffset(yOffset);
    props.onChange(yOffset);
  };

  useEffect(() => {
    onYOffsetChange();
  }, []);

  return <div ref={ref}>{props.children}</div>;
};

export default YOffsetAnnouncer;
